import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin, Clock, ArrowRight, Globe } from "lucide-react";
import { Separator } from "./ui/separator";
import { businessInfo } from "../data/mock";

export const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={businessInfo.logoUrl}
                alt="Om Sai Express Logo"
                className="w-12 h-12 rounded-full object-cover border-2 border-white/20"
              />
              <div>
                <h3 className="text-lg font-bold" style={{ fontFamily: "'Lora', serif" }}>Om Sai Express</h3>
                <p className="text-xs text-white/60 tracking-wider">COURIER & LOGISTICS</p>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed mb-4">
              Your trusted partner for safe, timely, and affordable courier and logistics solutions in New Delhi and across India.
            </p>
            <p className="text-xs text-white/50">
              GSTIN: {businessInfo.gstin}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white" style={{ fontFamily: "'Lora', serif" }}>Quick Links</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/services", label: "Services" },
                { to: "/track", label: "Track Shipment" },
                { to: "/contact", label: "Contact Us" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-white/70 hover:text-white flex items-center gap-2 transition-colors group"
                >
                  <ArrowRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                  <span>{link.label}</span>
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white" style={{ fontFamily: "'Lora', serif" }}>Our Services</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                "Domestic Courier",
                "Express Delivery",
                "Document Shipping",
                "Commercial Shipments",
                "Door-to-Door Pickup",
              ].map((service) => (
                <Link
                  key={service}
                  to="/services"
                  className="text-sm text-white/70 hover:text-white flex items-center gap-2 transition-colors group"
                >
                  <ArrowRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                  <span>{service}</span>
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white" style={{ fontFamily: "'Lora', serif" }}>Contact Us</h4>
            <div className="flex flex-col gap-3.5">
              <a href={`tel:${businessInfo.phone}`} className="flex items-start gap-3 text-sm text-white/70 hover:text-white transition-colors">
                <Phone className="w-4 h-4 mt-0.5 shrink-0 text-brand-light" />
                <span>{businessInfo.phone}</span>
              </a>
              <a href={businessInfo.whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm text-white/70 hover:text-white transition-colors">
                <MessageCircle className="w-4 h-4 mt-0.5 shrink-0 text-[#25D366]" />
                <span>{businessInfo.whatsapp}</span>
              </a>
              <a href={`mailto:${businessInfo.email}`} className="flex items-start gap-3 text-sm text-white/70 hover:text-white transition-colors">
                <Mail className="w-4 h-4 mt-0.5 shrink-0 text-brand-light" />
                <span>{businessInfo.email}</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-white/70">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-brand-light" />
                <span>{businessInfo.address}</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-white/70">
                <Clock className="w-4 h-4 mt-0.5 shrink-0 text-brand-light" />
                <span>Mon – Sat: 9:00 AM – 8:00 PM</span>
              </div>
              <a href={`https://${businessInfo.website}`} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm text-white/70 hover:text-white transition-colors">
                <Globe className="w-4 h-4 mt-0.5 shrink-0 text-brand-light" />
                <span>{businessInfo.website}</span>
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <p>&copy; {new Date().getFullYear()} Om Sai Express. All rights reserved.</p>
          <p>Trusted Courier & Logistics Partner in New Delhi</p>
        </div>
      </div>
    </footer>
  );
};
